import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Logout from "./pages/Logout";
import Login from "./pages/Login";
import Home from "./pages/home/Home";
import PrivateRoute from "./common/components/auth/PrivateRoute";
import RenterRegisterPage from "./modules/renters/RenterRegister.page";
import { useContext, useEffect } from "react";
import { setUser } from "@sentry/react";
import VehiclesRegisterPage from "./modules/vehicles/VehiclesRegister.page";
import RenterDetailsPage from "./modules/renters/RenterDetails.page";
import VehicleDetailsPage from "./modules/vehicles/VehicleDetails.page";
import { IndicatorsRegisterPage } from "./modules/indicators/IndicatorsRegister.page";
import IndicatorDetailsPage from "./modules/indicators/IndicatorDetail.page";
import LeadsRegisterPage from "./modules/leads/LeadRegister.page";
import LeadDetailsPage from "./modules/leads/LeadDetails.page";
import InventoryDetailsPage from "./modules/inventory/InventoryDetails.page";
import SupplierRegisterPage from "./modules/suppliers/SupplierRegister.page";
import CategoryRegisterPage from "./modules/category/CategoryRegister.page";
import SuppliersDetailsPage from "./modules/suppliers/SupplierDetails.page";
import { PartnerRegisterPage } from "./modules/partners/PartnerRegister.page";
import PartnerDetailsPage from "./modules/partners/PartnerDetails.page";
import CreateLeadByAmbassador from "./modules/ambassador/CreateLeadByAmbassador";
import { EmployeeRegisterPage } from "./modules/employee/EmployeeRegister.page";
import CreateAmbassador from "./modules/ambassador/CreateAmbassador";
import { AuthContext } from "./common/components/auth/authContext/AuthContext";
import PurchasePage from "./modules/purchase/Purchase.page";
import PurchaseCategoryRegister from "./modules/purchase-category/PurchaseCategoryRegister.page";
import PurchaseCostCenterRegister from "./modules/purchase-cost-center/PurchaseCostCenterRegister.page";
import CostCenterDetailsPage from "./modules/purchase-cost-center/PurchaseCostCenterDetails.page";
import PurchaseRequestorRegister from "./modules/purchase-requestor/PurchaseRequestorRegister.page";
import PurchasePurchaseOrderRegister from "./modules/purchase-order/PurchaseOrderRegister.page";
import PurchaseOrderDetailsPage from "./modules/purchase-order/PurchaseOrderDetails.page";
import { MaintenanceRegisterPage } from "./modules/maintenances/MaintenanceRegister.page";
import { MaintenanceReportsRegisterPage } from "./modules/reports/maintenances/MaintenanceReportsRegister.page";
import MaintenanceReportsDetailsPage from "./modules/reports/maintenances/MaintenanceReportsDetails.page";
import { PreparationReportsRegisterPage } from "./modules/reports/preparations/PreparationReportsRegister.page";
import PreparationsReportsDetailsPage from "./modules/reports/preparations/PreparationReportsDetails.page";
import { CommissionReportsRegisterPage } from "./modules/reports/comission/CommissionRegister.page";
import CommissionReportsDetailsPage from "./modules/reports/comission/CommissionDetails.page";
import ProductRegisterPage from "./modules/products/ProductRegister.page";
import { NfsRegisterPage } from "./modules/nfs/NfsRegister.page";
import NfsDetailsPage from "./modules/nfs/NfsDetails.page";
import WorkRegisterPage from "./modules/works/WorkRegister.page";
import { TrafficFinesReportsRegisterPage } from "./modules/reports/trafficfines/TrafficFinesReportsRegister.page";
import TutorialRegisterPage from "./modules/tutorial/TutorialRegisterPage";
import RepossessionRegisterage from "./modules/repossession/RepossessionRegister.page";
import PurchaseSuggestionRegister from "./modules/purchase-suggestion/PurchaseSuggestionRegister.page";
import TicketStockRegisterPage from "./modules/ticketStock/TicketStockRegister.page";
import PickupRaceForm from "./pages/PickupRace/PickupRaceForm";
import TrafficFineDetailsView from "./modules/reports/trafficfines/components/TrafficFineDetailsView";
import { RepossessionReportsRegister } from "./modules/reports/repossession/RepossessionReportsRegister.page";
import { DelinquencyRegisterPage } from "./modules/delinquency/DelinquencyRegister.page";
import { WaitingRescissionRegisterPage } from "./modules/delinquency/WaitingRescissionRegister.page";
import OperationalManagement from "./modules/operational-management/operational-management.page";
import ReceivablesManagement from "./modules/management-receivables/receivablesManagement.page";
import VehicleTrackersPage from "./modules/vehicle-trackers /VehicleTrackers.page";
import EventClaimPage from "./modules/insurance-claim/EventClaim.page";
import DashboardVehicles from "./pages/Dashboard/DashboardVehicles";
import ManagementBillingRegisterPage from "./modules/management-billing/ManagementBilling.page";
import MaintenanceSchedulesPage from "./modules/maintenance-schedules/MaintenanceSchedules.page";
import InventoryManagementPage from "./modules/inventory-management/InventoryManagement.page";
import ManagementBillingDetailsPage from "./modules/management-billing/ManagementBillingDetails.page";
import DashboardLeads from "./pages/Dashboard/DashboardLead";
import { PrintManager } from "./pages/print-manager/Print-manager";
import { PrintManagerConfig } from "./pages/print-manager/Print-manager-config";
import { RepossessionReportsCollectors } from "./modules/reports/repossession/RepossessionReportsCollectors.page";
import ProductDetailsPage from "./modules/products/ProductDetails.page";
import PurchaseRequisition from "./modules/purchase-requisition/PurchaseRequisitionRegister.page";
import PurchaseReturnRegister from "./modules/purchase-return/PurchaseReturn.page";
import PurchaseReturnDetailsPage from "./modules/purchase-return/PurchaseReturnDetails.page";
import RenterDetailsRescissionPage from "./modules/renters/components/delinquencies/RenterDetailsRescission.page";
import DashboardMaintenance from "./pages/Dashboard/maintenance/DashboardsMaintenance";
import RenterDetailsSubscription from "./modules/renters/components/manage-subscription/ManageSubscription.page";
import RenterDetailsInstallment from "./modules/renters/components/manage-installment/ManageInstallment.page";
import NegativationsRegisterPage from "./modules/renter-negativation/NegativationRegister.page";
import ExternalServicesRegister from "./modules/external-services/ExternalServicesRegister";
import InventoryVehiclesPage from "./modules/inventory-vehicles/InventoryVehicles.page";
import NegativationDetailsPage from "./modules/renter-negativation/NegativationDetails.page";
import LoanRegisterPage from "./modules/loan/LoanRegister.page";
import LoanDetailsPage from "./modules/loan/LoanDetails.page";
import InfractionTicketsPage from "./modules/infractionTickets/InfractionTickets.page";
import DevolutionDepositPage from "./modules/devolution-deposit/DevolutionDetails.page";
import InvoicePage from "./modules/invoice/Invoice.page";
import PrivateRouteWithCompanyValidation from "./common/components/auth/PrivateRouteWithCompanyValidation";
import ReferrealReports from "./modules/referral-report/referralReport.page";
import { ContestMaintenancePage } from "./modules/reports/contest-maintenance/ContestMaintenance.page";
import NegotiationDebitsDetails from "./modules/renters/components/negotiation-debits/page/NegotiationDetails.page";
import VehicleTransferPage from "./modules/vehicleTransfer/vehicleTransfer.page";
import CompanyManagementPage from "./modules/companies/CompanyManagement.page";
import MaintenanceCompleted from "./modules/MaintenanceCompleted/MaintenanceCompleted";
import { PreCollection } from "./pages/External/PreCollection/PreCollection.page";
import AuditsPage from "./modules/audits/AuditsPage";
import AuditsVehiclesMaintenancePage from "./modules/audits/sub-pages/AuditsVehiclesMaintenancePage";
import AutomaticRenewalsPage from "./modules/automaticRenewals/AutomaticRenewals.page";
import { StockInventoryPage } from "./modules/StockInventory/StockInventoryPage";
import Maintenance from "./modules/maintenances/maintenance/MaintenancePage";
import { IncomingInvoicesPage } from "./modules/IncomingInvoices/IncomingInvoices.page";
import { IncomingInvoicesDetailsPage } from "./modules/IncomingInvoices/IncomingInvoicesDetails.page";
import { PreparationReportsDetailsByPartnerPage } from "./modules/reports/preparations/PreparationReportsDetailsByPartner.page";

const router = createBrowserRouter([
  {
    path: "/event-claim",
    element: (
      <PrivateRoute>
        <EventClaimPage />
      </PrivateRoute>
    ),
  },
  {
    path: "impressora-senha/config",
    element: <PrintManagerConfig />,
  },
  {
    path: "impressora-senha",
    element: <PrintManager />,
  },
  {
    path: "/company-management",
    element: (
      <PrivateRoute>
        <CompanyManagementPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/maintenance-schedules",
    element: (
      <PrivateRoute>
        <MaintenanceSchedulesPage />
      </PrivateRoute>
    ),
  },

  {
    path: "/dashboard/frota",
    element: (
      <PrivateRoute>
        <DashboardVehicles />
      </PrivateRoute>
    ),
  },

  {
    path: "/dashboard/leads",
    element: (
      <PrivateRoute>
        <DashboardLeads />
      </PrivateRoute>
    ),
  },

  {
    path: "/dashboard/manutencao",
    element: (
      <PrivateRoute>
        <DashboardMaintenance />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/gestao-cobranca",
    element: (
      <PrivateRoute>
        <ReceivablesManagement />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/gestao-fatura",
    element: (
      <PrivateRoute>
        <ManagementBillingRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/negativados",
    element: (
      <PrivateRoute>
        <NegativationsRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/emprestimo",
    element: (
      <PrivateRoute>
        <LoanRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/infractionTickets",
    element: (
      <PrivateRoute>
        <InfractionTicketsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/emprestimo/:loanId",
    element: (
      <PrivateRoute>
        <LoanDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/caucao",
    element: (
      <PrivateRoute>
        <DevolutionDepositPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/automaticRenewals",
    element: (
      <PrivateRoute>
        <AutomaticRenewalsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/negativacao/:negativationId",
    element: (
      <PrivateRoute>
        <NegativationDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/gestao-fiscal",
    element: (
      <PrivateRoute>
        <InvoicePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/financeiro/gestao-fatura/:paymentId",
    element: (
      <PrivateRoute>
        <ManagementBillingDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "pickup-race/form/:companyId",
    element: <PickupRaceForm />,
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "logout",
    element: <Logout />,
  },
  {
    path: "recolhimento-externo",
    element: <PreCollection />,
  },
  {
    path: "clientes",
    element: (
      <PrivateRoute>
        <RenterRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "clientes/:renterId",
    element: (
      <PrivateRoute>
        <RenterDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "clientes/:renterId/assinaturas",
    element: (
      <PrivateRoute>
        <RenterDetailsSubscription />
      </PrivateRoute>
    ),
  },
  {
    path: "clientes/:renterId/parcelamentos",
    element: (
      <PrivateRoute>
        <RenterDetailsInstallment />
      </PrivateRoute>
    ),
  },
  {
    path: "clientes/:renterId/debitos",
    element: (
      <PrivateRoute>
        <NegotiationDebitsDetails />
      </PrivateRoute>
    ),
  },
  {
    path: "veiculos",
    element: (
      <PrivateRoute>
        <VehiclesRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "inventario",
    element: (
      <PrivateRoute>
        <InventoryVehiclesPage />
      </PrivateRoute>
    ),
  },
  {
    path: "veiculos/:licensePlate",
    element: (
      <PrivateRoute>
        <VehicleDetailsPage />
      </PrivateRoute>
    ),
  },

  {
    path: "indicadores",
    element: (
      <PrivateRoute>
        <IndicatorsRegisterPage />
      </PrivateRoute>
    ),
  },

  {
    path: "indicadores/:indicatorId",
    element: (
      <PrivateRoute>
        <IndicatorDetailsPage />
      </PrivateRoute>
    ),
  },

  {
    path: "manutencao",
    element: (
      <PrivateRoute>
        <MaintenanceRegisterPage />
      </PrivateRoute>
    ),
  },

  {
    path: "manutencao/:licensePlate/budget",
    element: (
      <PrivateRoute>
        <MaintenanceRegisterPage />
      </PrivateRoute>
    ),
  },

  {
    path: "leads",
    element: (
      <PrivateRoute>
        <LeadsRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "leads/:leadId",
    element: (
      <PrivateRoute>
        <LeadDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "estoque",
    element: (
      <PrivateRoute>
        <InventoryDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/controle-equipamentos",
    element: (
      <PrivateRoute>
        <InventoryManagementPage />
      </PrivateRoute>
    ),
  },
  {
    path: "categorias",
    element: (
      <PrivateRoute>
        <CategoryRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "fornecedores",
    element: (
      <PrivateRoute>
        <SupplierRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "fornecedores/:supplierId",
    element: (
      <PrivateRoute>
        <SuppliersDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "produtos",
    element: (
      <PrivateRoute>
        <ProductRegisterPage></ProductRegisterPage>
      </PrivateRoute>
    ),
  },
  {
    path: "produto/:productId",
    element: (
      <PrivateRoute>
        <ProductDetailsPage></ProductDetailsPage>
      </PrivateRoute>
    ),
  },
  {
    path: "servicos",
    element: (
      <PrivateRoute>
        <WorkRegisterPage></WorkRegisterPage>
      </PrivateRoute>
    ),
  },
  {
    path: "nfs",
    element: (
      <PrivateRoute>
        <NfsRegisterPage></NfsRegisterPage>
      </PrivateRoute>
    ),
  },
  {
    path: "stock-inventario",
    element: <StockInventoryPage />,
  },
  {
    path: "retiradaDeEstoque",
    element: (
      <PrivateRoute>
        <TicketStockRegisterPage></TicketStockRegisterPage>
      </PrivateRoute>
    ),
  },
  {
    path: "nfs/:stockId",
    element: (
      <PrivateRoute>
        <NfsDetailsPage></NfsDetailsPage>
      </PrivateRoute>
    ),
  },
  {
    path: "compras",
    element: (
      <PrivateRoute>
        <PurchasePage />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/devolucao",
    element: (
      <PrivateRoute>
        <PurchaseReturnRegister />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/devolucao/:purchaseReturnId",
    element: (
      <PrivateRoute>
        <PurchaseReturnDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/NFSEntry",
    element: (
      <PrivateRoute>
        <IncomingInvoicesPage />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/NFSEntry/:NFSEntryId",
    element: (
      <PrivateRoute>
        <IncomingInvoicesDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/categorias",
    element: (
      <PrivateRoute>
        <PurchaseCategoryRegister />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/categorias/:categoryId",
    element: (
      <PrivateRoute>
        <PurchaseCategoryRegister />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/centroDeCustos",
    element: (
      <PrivateRoute>
        <PurchaseCostCenterRegister />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/centroDeCusto/:costCenterId",
    element: (
      <PrivateRoute>
        <CostCenterDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/solicitante",
    element: (
      <PrivateRoute>
        <PurchaseRequestorRegister />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/ordem",
    element: (
      <PrivateRoute>
        <PurchasePurchaseOrderRegister />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/ordem/:purchaseOrderId",
    element: (
      <PrivateRoute>
        <PurchaseOrderDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "compras/sugestaoDeCompra",
    element: (
      <PrivateRoute>
        <PurchaseSuggestionRegister />
      </PrivateRoute>
    ),
  },

  {
    path: "compras/servicosExternos",
    element: (
      <PrivateRoute>
        <ExternalServicesRegister />
      </PrivateRoute>
    ),
  },

  {
    path: "compras/requestordem",
    element: (
      <PrivateRoute>
        <PurchaseRequisition />
      </PrivateRoute>
    ),
  },
  {
    path: "",
    element: (
      <PrivateRoute>
        <PrivateRouteWithCompanyValidation>
          <Home />
        </PrivateRouteWithCompanyValidation>
      </PrivateRoute>
    ),
  },
  {
    path: "parceiros",
    element: (
      <PrivateRoute>
        <PartnerRegisterPage />
      </PrivateRoute>
    ),
  },

  {
    path: "parceiros/:partnerId",
    element: (
      <PrivateRoute>
        <PartnerDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "embaixador",
    element: <CreateAmbassador />,
  },
  {
    path: "embaixador/:ambassadorCode",
    element: <CreateLeadByAmbassador />,
  },
  {
    path: "colaboradores/",
    element: (
      <PrivateRoute>
        <EmployeeRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "colaboradores/:employeeId",
    element: (
      <PrivateRoute>
        <EmployeeRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/manutencao",
    element: (
      <PrivateRoute>
        <MaintenanceReportsRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/manutencao/:licensePlate",
    element: (
      <PrivateRoute>
        <MaintenanceReportsDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/preparacoes/details/:companyName",
    element: (
      <PrivateRoute>
        <PreparationReportsDetailsByPartnerPage />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/comissoes",
    element: (
      <PrivateRoute>
        <CommissionReportsRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/comissoes/:technicalConsultant",
    element: (
      <PrivateRoute>
        <CommissionReportsDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/preparacoes",
    element: (
      <PrivateRoute>
        <PreparationReportsRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/preparacoes/:workOrderId",
    element: (
      <PrivateRoute>
        <PreparationsReportsDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/multas",
    element: (
      <PrivateRoute>
        <TrafficFinesReportsRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/RelatorioIndicacoes",
    element: (
      <PrivateRoute>
        <ReferrealReports />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/MaintenanceCompleted",
    element: (
      <PrivateRoute>
        <MaintenanceCompleted />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/multas/:trafficTicket",
    element: (
      <PrivateRoute>
        <TrafficFineDetailsView />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/recolhimento",
    element: (
      <PrivateRoute>
        <RepossessionReportsRegister />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/recolhimento/recolhedores",
    element: (
      <PrivateRoute>
        <RepossessionReportsCollectors />
      </PrivateRoute>
    ),
  },
  {
    path: "relatorios/contestacoes",
    element: (
      <PrivateRoute>
        <ContestMaintenancePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/operational-management",
    element: (
      <PrivateRoute>
        <OperationalManagement />
      </PrivateRoute>
    ),
  },
  {
    path: "/maintenances",
    element: (
      <PrivateRoute>
        <Maintenance />
      </PrivateRoute>
    ),
  },
  {
    path: "recolhimento",
    element: (
      <PrivateRoute>
        <RepossessionRegisterage />
      </PrivateRoute>
    ),
  },
  {
    path: "tutoriais",
    element: (
      <PrivateRoute>
        <TutorialRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "finalizados",
    element: (
      <PrivateRoute>
        <DelinquencyRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "finalizados/:renterId",
    element: (
      <PrivateRoute>
        <RenterDetailsRescissionPage />
      </PrivateRoute>
    ),
  },
  {
    path: "aguardandoRecisao",
    element: (
      <PrivateRoute>
        <WaitingRescissionRegisterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "aguardandoRecisao/:renterId",
    element: (
      <PrivateRoute>
        <RenterDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/vehicle-transfer",
    element: (
      <PrivateRoute>
        <VehicleTransferPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/audits",
    element: (
      <PrivateRoute>
        <AuditsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/audits/vehicles-maintenance",
    element: (
      <PrivateRoute>
        <AuditsVehiclesMaintenancePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/audits/vehicle-trackers",
    element: (
      <PrivateRoute>
        <VehicleTrackersPage />
      </PrivateRoute>
    ),
  },
]);

function Routes() {
  const { auth } = useContext(AuthContext);

  useEffect(() => {
    async function loadToken() {
      const token = (await auth?.getToken()) as string;

      if (!window["z__z"]) {
        window["z__z"] = () => token;
      }
    }
    loadToken();
  }, [auth]);

  auth ? setUser({ name: auth.user.name }) : setUser(null);

  return <RouterProvider router={router} />;
}

export default Routes;
